<template>
  <div class="profile-circle">
    F
  </div>
</template>

<script>
export default {
  name: 'profile-circle',
};
</script>

<style scoped lang="scss">
.profile-circle {
  width: 100px;          /* Adjust size as needed */
  height: 100px;         /* Adjust size as needed */
  border-radius: 50%;    /* Makes the div a circle */
  background-color: $secondary;  /* Adjust background color as needed */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;          /* Text color */
  font-size: 40px;       /* Adjust font size as needed */
  font-weight: bold;
  text-align: center;
}
</style>
